import Page from '../model/Page';

const getPaginationTotalLabel = <T extends Page>(page: T | null
  | undefined, pageNumber: number, label = 'Akty'): string => {
  if (!page) {
    return '';
  }
  const lastPage: number = page.totalElements > 0
    ? Math.ceil(page.totalElements / page.size) : 1;
  let currentPage: number = pageNumber > lastPage ? lastPage : pageNumber;
  if (currentPage < 1) {
    currentPage = 1;
  }
  const rangeTop = page.size * currentPage;
  const rangeBottom = page.totalElements === 0 ? 0 : rangeTop - page.size + 1;
  const range = `${rangeBottom} - ${rangeTop > page.totalElements
    ? page.totalElements : rangeTop}`;

  return `${label} ${range} z ${page.totalElements}`;
};

export default getPaginationTotalLabel;
